export default "__VITE_ASSET__41cac28e__"